
// src/components/Header.js
import React from 'react';
// import SearchBar from './SearchBar';

const Header = () => (
  <header className="sticky top-0 z-40 flex items-center justify-between w-full px-2 border-b h-14 bg-background sm:px-10">
    <div className="flex items-center w-full mr-6 gap-x-2">
    <img src="/rte.png" width='40px' className='icon' />
      <span className="inline-block gabarito" style={{ fontSize: '15px' }}>

        Reading time estimator
      </span>
      <div className="grow md:max-w-[500px]">
        {/* <SearchBar /> */}
      </div>
    </div>
  </header>
);

export default Header;